<template>
  <div>
    <v-container v-if="roomTypes">
      <ErrorMessage
        v-if="isValidRoomTypes"
        message="Необходимо создать хотя бы один тип комнат"
      />
      <v-col v-if="roomTypes.length">
        <v-row align="center">
          <v-btn
            small
            text
            @click="togglePanels(roomTypes.map((item, itemIndex) => itemIndex))"
          >
            Развернуть все
          </v-btn>
          <v-divider vertical />
          <v-btn small text @click="togglePanels"> Свернуть все </v-btn>
        </v-row>
      </v-col>
      <v-spacer />
      <v-row no-gutters align="center" justify="end">
        <v-btn @click="$emit('create')">
          <v-icon class="pr-1"> mdi-plus </v-icon>
          <span>Создать</span>
        </v-btn>
      </v-row>
      <v-row>
        <v-expansion-panels multiple class="list-group" :value="expansionPanels">
          <draggable
            :value="roomTypes"
            handle=".handle"
            class="row no-gutters"
            @start="togglePanels"
            @input="$emit('list-sort', $event)"
          >
            <!-- <transition-group class="row no-gutters"> -->
            <v-expansion-panel
              class="mb-5 list-group-item"
              v-for="(item, itemIndex) in roomTypes"
              :key="itemIndex"
            >
              <v-expansion-panel-header>
                <v-row align="center">
                  <span
                    :class="[
                      errorMessages.$invalid && errorMessages.$dirty
                        ? 'error&#45;&#45;text'
                        : ''
                    ]"
                  >
                    {{ item.title || itemIndex + 1 }}
                  </span>
                </v-row>
                <template #actions>
                  <v-menu transition="scroll-y-transition" offset-y>
                    <template #activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" @click.stop.prevent="() => {}">
                        <v-icon> mdi-dots-vertical </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        dense
                        v-for="(option, optionIndex) in $options.itemOptions"
                        :key="optionIndex"
                        :style="{ [option.borderDirection]: option.borderStyle }"
                        @click="optionHandler(option, itemIndex, item)"
                      >
                        {{ option.title }}
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <InputTitleSlug
                  :is-slug-enabled="false"
                  :is-loading="loading"
                  :title="item.title"
                  :title-error="getFieldErrorMessage(itemIndex, 'title')"
                  @change:title="item.title = $event"
                />
                <v-row>
                  <v-col cols="12">
                    <MediaFilePicker
                      :label="'Изображения*'"
                      :file-type="$options.mediaTypesByKeys.IMAGE"
                      :value="item.images"
                      @change="item.images = $event"
                    >
                      <template #preview-bottom>
                        <ErrorMessage
                          :message="getFieldErrorMessage(itemIndex, 'images')"
                        />
                      </template>
                    </MediaFilePicker>
                  </v-col>
                </v-row>
                <v-row>
                  <span>Описание* (<TranslationIcon />)</span>
                  <QuillEditorVue
                    :cols="12"
                    :title="''"
                    :content="item.description"
                    :isShowErrorMessage="true"
                    :errorText="getFieldErrorMessage(itemIndex, 'description')"
                    light-mode
                    @input="item.description = $event"
                    @onChangeContent="$emit('change:descriptionForMobile', {itemIndex, descForMob: $event })"
                  />
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Количество гостей*</span>
                    <v-text-field
                      v-model.number="item.maxGuests"
                      outlined
                      :disabled="loading"
                      :loading="loading"
                      :error-messages="getFieldErrorMessage(itemIndex, 'maxGuests')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Количество взрослых мест*</span>
                    <v-text-field
                      v-model.number="item.maxAdults"
                      outlined
                      :disabled="loading"
                      :loading="loading"
                      :error-messages="getFieldErrorMessage(itemIndex, 'maxAdults')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Количество детских мест*</span>
                    <v-text-field
                      v-model.number="item.maxChildren"
                      outlined
                      :disabled="loading"
                      :loading="loading"
                      :error-messages="getFieldErrorMessage(itemIndex, 'maxChildren')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Базовая цена*</span>
                    <v-text-field
                      v-model.number="item.basePrice"
                      outlined
                      :disabled="loading"
                      :loading="loading"
                      :error-messages="
                        getFieldErrorMessage(
                          itemIndex,
                          'basePrice',
                          'Обязательное поле. Только числовые значения'
                        )
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <span>Удобства</span>
                    <v-select
                      chips
                      :disabled="loading"
                      :loading="loading"
                      outlined
                      item-value="id"
                      item-text="label"
                      multiple
                      :items="amenities"
                      v-model="item.amenities"
                    >
                      <template #selection="{ item }">
                        <v-chip>
                          {{ item.label }}
                        </v-chip>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- </transition-group> -->
          </draggable>
        </v-expansion-panels>
      </v-row>
      <ConfirmationDialog ref="confirm" confirmText="ОК" />
    </v-container>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import ConfirmationDialog from '@/components/confirmation-dialog/ConfirmationDialog'
import Option from '@/utils/options/Option'
import TranslationIcon from '@/components/translation-icon/translationIcon'
import InputTitleSlug from '@/components/inputs/InputTitleSlug'
import { mediaTypesByKeys } from '@/configs/mediaFileTypes'
import MediaFilePicker from '@/components/media-file-picker'
import ErrorMessage from '@/components/error-messages/ErrorMessage'
import QuillEditorVue from '@/components/quill-editor'

const itemOptions = [
  // new Option('Дублировать', 'duplicate'),
  new Option('Удалить', 'delete', 'borderTop', true)
]
export default {
  name: 'FormHotelRoomTypes',
  itemOptions,
  mediaTypesByKeys: mediaTypesByKeys(),
  components: {
    ErrorMessage,
    InputTitleSlug,
    TranslationIcon,
    draggable,
    ConfirmationDialog,
    MediaFilePicker,
    QuillEditorVue
  },
  props: {
    roomTypes: {
      type: Array,
      required: true,
      default: () => []
    },
    amenities: {
      type: Array,
      required: true,
      default: () => []
    },
    errorMessages: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    isValidRoomTypes: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expansionPanels: []
    }
  },
  methods: {
    getFieldErrorMessage (index, fieldName, msg = 'Обязательное поле') {
      if (this.errorMessages[index] === undefined) return ''
      const v = this.errorMessages[index][fieldName]
      return v.$invalid && v.$dirty ? [msg] : []
    },
    togglePanels (list = []) {
      this.expansionPanels = list
    },
    async optionHandler (option, itemIndex, item) {
      const { isConfirm } = option
      if (isConfirm && this.$refs.confirm) await this.$refs.confirm.open()
      this.$emit('option', {
        option,
        itemIndex,
        item
      })
    }
  }
}
</script>
